export const ERROR_CODE_MAP = {
  8: '系统错误',
  1101: '签名错误',
  1118: '账号不存在',
  1124: '绑定到三方信息失败',
  1133: '三方信息校验失败',
  1134: '三方信息与fpid不匹配',
  1135: 'unbind时，根据三方信息找不到fpid',
  1151: '参数无效',
  1152: 'auth token无效',
  1153: '三方信息已经绑定到其他fpid了',
  1154: '三方账号绑定的fpid超出限制',
  30009: '链接支付服务器异常（30009）',
  40001: '目前登录社交账号与绑定账号不一致（40001）',
  30005: '对应商品不存在（30005）',
  52003: '对应商品不存在（52003）',
  30001: '数据异常（30001）',
  46002: '用户取消登录（46002）',
  20014: '数据异常（20014）',
  20018: '该社交账号已经绑定其他游戏数据（20018）',
  41003: '获取Facebook用户信息失败（41003）',
  43002: '获取VK用户信息失败（错误43002）',
  30008: '链接支付服务器异常（30008）',
  42101: 'Play Games账号验证失败（42101）',
  52002: '已取消操作（52002）',
  42001: '链接Google失败（42001）',
  30004: '链接支付服务器异常（30004）',
  20011: '数据异常（20011）',
  44002: '获取用户信息失败（44002）',
  46003: '账号验证未通过（46003）',
  20015: '数据异常（20015）',
  10002: '账号数据异常（10002）',
  20019: '数据异常（20019）',
  41002: '已取消操作（41002）',
  30007: '链接支付服务器异常（30007）',
  52005: '数据异常（52005）',
  42002: 'Google授权失败（42002）',
  30003: '数据异常（30003）',
  52001: 'Google初始化失败（52001）',
  41001: '链接Face book失败（41001）',
  10001: '数据异常（10001）',
  20016: '未找到绑定信息（20016）',
  44001: '链接Game Center失败（44001）',
  30002: '数据异常（30002）',
  52004: '对应商品不存在（52004）',
  20020: '注册过于频繁，请稍后重试',
  30006: '对应商品不存在（30006）',
  10012: '数据异常（10012）',
  43001: '链接VK失败（43001）',
  20013: '数据异常（20013）',
  46001: '登录请求失败（46001）',
  10000: 'http网络错误(非 200)',
  '-1': '请求失败',
  '990001': '账号处于冷静期',
  '990002': '账号以删除',
  '100002': '参数错误',
  '110002': '登录失败',
  '110004': '手机号格式不正确',
  '110009': '验证码不正确',
  '110010': '验证码过期',
  '110011': '需要行为验证',
  '110014': '行为异常，禁止登录',
  '400004_46001': '和微端建立连接失败',
  '400004_30002': '和微端连接已关闭',
  'WS_CLOSED': 'ws 已关闭',
  '500000': '和微端建立连接失败',
  '500001': '和微端连接已关闭',
  '1001': '绑定/解绑时当前 fpid 和微端 fpid 不一致',
  /** start 仅在微端登录注册新用户时上报 */
  '20016_register': '点击新建账号',
  '20016_register_suc': '新建账号成功'
  /** end 仅在微端登录注册新用户时上报 */
}